import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import type { ComponentProps } from "react";
import * as React from "react";
import type { DayPicker } from "react-day-picker";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

type DatePickerProps = ComponentProps<typeof DayPicker> & {
  date?: Date;
  onChange: (date: Date) => void;
  btnClassname?: string;
};

export default function DatePicker({ date, onChange, btnClassname, ...other }: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn("w-fit justify-start text-left font-normal", !date && "text-muted-foreground", btnClassname)}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? format(date, "PPP") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        {/* @ts-ignore*/}
        <Calendar mode="single" selected={date} onSelect={onChange} initialFocus {...other} />
      </PopoverContent>
    </Popover>
  );
}
